export default "__VITE_ASSET__B2P$t_CT__"